export default "__VITE_ASSET__DSL7$Ssy__"